<template>
  <div class="sidebar" :class="{
      'sidebar-expanding': expanding,
      'sidebar-chinese': language === 'zh-CN',
      'sidebar-english': language !== 'zh-CN'
    }">
    <el-menu
      mode="vertical"
      v-bind="$attrs"
      :unique-opened="uniqueOpened"
      :default-active="$route.path"
      @select="handleSelect"
      :collapseTransition="false"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </div>
</template>

<script>
import SidebarItem from './sidebar-item.vue'

export default {
  name: 'XpSidebar',
  components: { SidebarItem },
  props: {
    routes: {
      type: Array,
      required: true
    },
    uniqueOpened: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expanding: this.$store.state.sideBarCollapse,
      language: this.$i18n.locale
    }
  },
  watch: {
    '$i18n.locale'(newVal) {
      this.language = newVal;
    },
    '$store.state.sideBarCollapse'(newVal) {
      this.expanding = newVal;
    }
  },
  methods: {
    handleSelect( path ) {
      this.$emit( 'select', path )
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 0;
  bottom: 0;
  overflow-y: auto;
  background-color: #373d41;
  border-right: 1px solid #e6e6e6;
  &.sidebar-chinese {
    width: 200px;
  }
  &.sidebar-english {
    width: 256px;
  }
  &.sidebar-expanding {
    width: 64px;
  }
}
</style>
